// DO NOT EDIT -- generated from fs/services/dx-objects/dxobjectsinternal.proto

import * as protoauditstore from '../../gcloud/dstore/protoauditstore';

export namespace DxObjectsInternal {

  export const GetDefinedEventsEndpoint = "/grpc/dx_objects.DxObjectsInternal/GetDefinedEvents";
  export function GetDefinedEvents(sender: (req: GetDefinedEventsRequest, endpoint: string) => Promise<GetDefinedEventsResponse>, req: GetDefinedEventsRequest): { promise: () => Promise<GetDefinedEventsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDefinedEventsEndpoint),
      endpoint: GetDefinedEventsEndpoint
    };
  }

  export const GetNamedElementsEndpoint = "/grpc/dx_objects.DxObjectsInternal/GetNamedElements";
  export function GetNamedElements(sender: (req: GetNamedElementsRequest, endpoint: string) => Promise<GetNamedElementsResponse>, req: GetNamedElementsRequest): { promise: () => Promise<GetNamedElementsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetNamedElementsEndpoint),
      endpoint: GetNamedElementsEndpoint
    };
  }

  export const GetPagesEndpoint = "/grpc/dx_objects.DxObjectsInternal/GetPages";
  export function GetPages(sender: (req: GetPagesRequest, endpoint: string) => Promise<GetPagesResponse>, req: GetPagesRequest): { promise: () => Promise<GetPagesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPagesEndpoint),
      endpoint: GetPagesEndpoint
    };
  }
}

export interface GetDefinedEventsRequest {
  orgId: string;
}

export interface GetDefinedEventsResponse {
  definedEvents: GetDefinedEventsResponse.DefinedEvent[];
}

export namespace GetDefinedEventsResponse {
  export interface DefinedEvent {
    id: string;
    name: string;
    description: string;
    metadata: protoauditstore.AuditMetadata | null;
  }
}

export interface GetNamedElementsRequest {
  orgId: string;
}

export interface GetNamedElementsResponse {
  namedElements: GetNamedElementsResponse.NamedElement[];
}

export namespace GetNamedElementsResponse {
  export interface NamedElement {
    id: string;
    name: string;
    description: string;
    metadata: protoauditstore.AuditMetadata | null;
  }
}

export interface GetPagesRequest {
  orgId: string;
}

export interface GetPagesResponse {
  pages: GetPagesResponse.Page[];
}

export namespace GetPagesResponse {
  export interface Page {
    id: number;
    name: string;
    description: string;
    friendlyId: string;
    isUserDefined: boolean;
    metadata: protoauditstore.AuditMetadata | null;
  }
}
